// extracted by mini-css-extract-plugin
export default {"list":"List_list__469Om","list__item":"List_list__item__s1Yc1","list__title":"List_list__title__9YerD"};